export default __webpack_public_path__ + "static/media/Cotidiano_favelado_2.7dd0d4e4.jpg";